import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const ExternalLinkIcon: React.FC<SVGComponentProps> = ({
    width = 12,
    height = 12,
    fill = '#2563eb'
}) => (
    <SVGUniqueID>
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.80039 0.468872C6.35856 0.468872 6.00039 0.827044 6.00039 1.26887C6.00039 1.7107 6.35856 2.06887 6.80039 2.06887H8.86902L3.83471 7.10319C3.52229 7.41561 3.52229 7.92214 3.83471 8.23456C4.14712 8.54698 4.65366 8.54698 4.96608 8.23456L10.0004 3.20024V5.26887C10.0004 5.7107 10.3586 6.06887 10.8004 6.06887C11.2422 6.06887 11.6004 5.7107 11.6004 5.26887V1.26887C11.6004 0.827044 11.2422 0.468872 10.8004 0.468872H6.80039Z"
                fill={fill}
            />
            <path
                d="M2.00039 2.06887C1.11674 2.06887 0.400391 2.78522 0.400391 3.66887V10.0689C0.400391 10.9525 1.11673 11.6689 2.00039 11.6689H8.40039C9.28405 11.6689 10.0004 10.9525 10.0004 10.0689V7.66887C10.0004 7.22705 9.64222 6.86887 9.20039 6.86887C8.75856 6.86887 8.40039 7.22705 8.40039 7.66887V10.0689H2.00039V3.66887L4.40039 3.66887C4.84222 3.66887 5.20039 3.3107 5.20039 2.86887C5.20039 2.42704 4.84222 2.06887 4.40039 2.06887H2.00039Z"
                fill={fill}
            />
        </svg>
    </SVGUniqueID>
);

export { ExternalLinkIcon };

